import React from 'react';
import { useTranslation } from 'react-i18next';
import PageBanner from '../layout/PageBanner';
import { IMAGES } from '../layout/theme';

import AccordionBlog from '../components/AccordionBlog';
import WithUs from '../components/WithUs';
import TestimonialBlog from '../components/TestimonialBlog';
import TouchStart from '../components/TouchStart';
import OurBlog from '../components/OurBlog';

const Faq = () => {
    const { t } = useTranslation();

    // General Property Management FAQs
    const generalFaqs = [
      { title: t('faqPage.q1'), content: t('faqPage.a1') },
      { title: t('faqPage.q2'), content: t('faqPage.a2') },
      { title: t('faqPage.q3'), content: t('faqPage.a3') },
      { title: t('faqPage.q4'), content: t('faqPage.a4') },
      { title: t('faqPage.q5'), content: t('faqPage.a5') },
    ];

    // Guest & Services FAQs
    const serviceFaqs = [
      { title: t('faqPage.q6'), content: t('faqPage.a6') },
      { title: t('faqPage.q7'), content: t('faqPage.a7') },
      { title: t('faqPage.q8'), content: t('faqPage.a8') },
      { title: t('faqPage.q9'), content: t('faqPage.a9') },
      { title: t('faqPage.q10'), content: t('faqPage.a10') },
    ];

    // Getting Started & Pricing FAQs
    const pricingFaqs = [
      { title: t('faqPage.q11'), content: t('faqPage.a11') },
      { title: t('faqPage.q12'), content: t('faqPage.a12') },
      { title: t('faqPage.q13'), content: t('faqPage.a13') },
      { title: t('faqPage.q14'), content: t('faqPage.a14') },
      { title: t('faqPage.q15'), content: t('faqPage.a15') },
    ];

    return (
        <>
          <PageBanner parentPage={t('faqPage.parentPage')} activePage={t('faqPage.activePage')} motherMenu={t('faqPage.motherMenu')} />

          {/* Main FAQ Section - All Questions */}
          <section className="main-faq-content" style={{ background: 'linear-gradient(180deg, #f8f9fa 0%, #ffffff 100%)' }}>
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-12">
                      <div className="center-title" style={{ paddingBottom: '20px' }}>
                        <span className="sub-title" style={{
                          fontSize: '16px',
                          letterSpacing: '3px',
                          fontWeight: '700'
                        }}>
                          {t('faqPage.subtitle')}
                        </span>
                        <h2 className="h2-title" style={{
                          marginTop: '20px',
                          marginBottom: '20px',
                          fontSize: '42px',
                          fontWeight: '700',
                          lineHeight: '1.3'
                        }}>
                          {t('faqPage.title')}
                        </h2>
                        <div style={{
                          maxWidth: '80px',
                          height: '4px',
                          background: 'linear-gradient(90deg, transparent, #d89d37, transparent)',
                          margin: '0 auto 25px',
                          borderRadius: '2px'
                        }}></div>
                        <p style={{
                          color: '#5a6c7d',
                          fontSize: '19px',
                          lineHeight: '1.8',
                          maxWidth: '750px',
                          margin: '0 auto',
                          fontWeight: '400'
                        }}>
                          {t('faqPage.faq2Desc')}
                        </p>
                      </div>
                  </div>
                </div>

                {/* Category 1: General Property Management */}
                <div className="row justify-content-center" style={{ marginTop: '60px' }}>
                  <div className="col-lg-10">
                    <div style={{ marginBottom: '50px' }}>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '15px',
                        marginBottom: '30px',
                        paddingBottom: '15px',
                        borderBottom: '2px solid #f0f0f0'
                      }}>
                        <div style={{
                          width: '50px',
                          height: '50px',
                          background: 'linear-gradient(135deg, #d89d37 0%, #f0c674 100%)',
                          borderRadius: '12px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#ffffff',
                          fontSize: '24px',
                          fontWeight: '700',
                          flexShrink: '0',
                          boxShadow: '0 4px 15px rgba(216, 157, 55, 0.25)'
                        }}>
                          01
                        </div>
                        <h3 style={{
                          fontSize: '26px',
                          fontWeight: '700',
                          color: '#2c3d4f',
                          margin: '0',
                          lineHeight: '1.3'
                        }}>
                          {t('faqPage.categoryGeneral')}
                        </h3>
                      </div>
                      <div className="faq-accordion accordion-style">
                        <AccordionBlog arrayData={generalFaqs}/>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Category 2: Guest & Services */}
                <div className="row justify-content-center">
                  <div className="col-lg-10">
                    <div style={{ marginBottom: '50px' }}>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '15px',
                        marginBottom: '30px',
                        paddingBottom: '15px',
                        borderBottom: '2px solid #f0f0f0'
                      }}>
                        <div style={{
                          width: '50px',
                          height: '50px',
                          background: 'linear-gradient(135deg, #d89d37 0%, #f0c674 100%)',
                          borderRadius: '12px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#ffffff',
                          fontSize: '24px',
                          fontWeight: '700',
                          flexShrink: '0',
                          boxShadow: '0 4px 15px rgba(216, 157, 55, 0.25)'
                        }}>
                          02
                        </div>
                        <h3 style={{
                          fontSize: '26px',
                          fontWeight: '700',
                          color: '#2c3d4f',
                          margin: '0',
                          lineHeight: '1.3'
                        }}>
                          {t('faqPage.categoryServices')}
                        </h3>
                      </div>
                      <div className="faq-accordion accordion-style">
                        <AccordionBlog arrayData={serviceFaqs}/>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Category 3: Getting Started & Pricing */}
                <div className="row justify-content-center">
                  <div className="col-lg-10">
                    <div style={{ marginBottom: '0' }}>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '15px',
                        marginBottom: '30px',
                        paddingBottom: '15px',
                        borderBottom: '2px solid #f0f0f0'
                      }}>
                        <div style={{
                          width: '50px',
                          height: '50px',
                          background: 'linear-gradient(135deg, #d89d37 0%, #f0c674 100%)',
                          borderRadius: '12px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#ffffff',
                          fontSize: '24px',
                          fontWeight: '700',
                          flexShrink: '0',
                          boxShadow: '0 4px 15px rgba(216, 157, 55, 0.25)'
                        }}>
                          03
                        </div>
                        <h3 style={{
                          fontSize: '26px',
                          fontWeight: '700',
                          color: '#2c3d4f',
                          margin: '0',
                          lineHeight: '1.3'
                        }}>
                          {t('faqPage.categoryPricing')}
                        </h3>
                      </div>
                      <div className="faq-accordion accordion-style">
                        <AccordionBlog arrayData={pricingFaqs}/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Call to Action */}
            <section className="main-with-us">
                <WithUs />
            </section>

            {/* Testimonials */}
            <section className="main-testimonial">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="center-title">
                                <span className="sub-title">{t('faqPage.testimonialSubtitle')}</span>
                                <h2 className="h2-title">{t('faqPage.testimonialTitle')}</h2>
                            </div>
                        </div>
                    </div>
                    <TestimonialBlog />
                </div>
            </section>

            {/* Contact Form */}
            <section className="main-contact">
                <div className="container">
                    <TouchStart />
                </div>
            </section>

            {/* Blog Section */}
            <section className="main-our-blog">
                <OurBlog />
            </section>
        </>
    );
};

export default Faq;
